const subNavActive = () => {
  const items = document.querySelectorAll('[data-sub-menu-item]')

  const urlStripped = window.location.href.replace('?page=', '').replace(/[0-9]/g, '');

  window.addEventListener('load', () => {
    items.forEach(item => {
      const itemUrlStripped = item.href.replace('?page=', '').replace(/[0-9]/g, '');

      if(itemUrlStripped === urlStripped) {
        item.classList.add('active')
        item.classList.remove('cta--inactive')
      } else {
        item.classList.remove('active')
        item.classList.add('cta--inactive')
      }
    })
  })
}

export default subNavActive;
